import { gql } from '@apollo/client';
import {
  ArticleSummary,
  MutationGenerateArticleSummaryArgs,
} from '../../../__generated__/queries-web';

export const GENERATE_ARTICLE_SUMMARY = gql`
  mutation GenerateArticleSummary($article: ArticleUniqueFilterInput!) {
    generateArticleSummary(article: $article) {
      id
      body
      status
      createdAt
      updatedAt
    }
  }
`;

export interface GenerateArticleSummaryMutation {
  generateArticleSummary: Pick<
    ArticleSummary,
    'id' | 'body' | 'status' | 'createdAt' | 'updatedAt'
  >;
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- type alias for generated args
export type GenerateArticleSummaryMutationVariables = MutationGenerateArticleSummaryArgs;
